export const UPDATE_PAGE_STATE = 'UPDATE_PAGE_STATE';

export const PAGE_CHANGED = 'PAGE_CHANGED';
export const PAGE_LOADING = 'PAGE_LOADING';
export const PAGE_LOADED = 'PAGE_LOADED';

export const SHOW_WEB_NOTIFICATON = 'SHOW_WEB_NOTIFICATON';
export const RESET_WEB_NOTIFICATON = 'RESET_WEB_NOTIFICATON';

export const GLOBAL_UPDATE_MESSAGE = 'GLOBAL_UPDATE_MESSAGE';
export const GLOBAL_UPDATE_PROFILE_DATA_IN_CONVERSATIONS = 'GLOBAL_UPDATE_PROFILE_DATA_IN_CONVERSATIONS';

export const UPDATE_AGENT_STATE_LIST = 'UPDATE_AGENT_STATE_LIST';




// WEBPACK FOOTER //
// ./src/data/redux/page_details/actiontypes.js